import styled from "styled-components";
import { theme } from "uikit";

const Title = styled.div`
	font-family: "Lato";
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 14px;

	color: ${theme.colors.primary};
`;

export default Title;
